export const LIVE_STATUS_OPTIONS = [
  { id: "all", label: "All" },
  { id: "live", label: "Live" },
  { id: "test", label: "Test" },
];

export const ACTIVE_STATUS_OPTIONS = [
  { id: "all", label: "All" },
  { id: "enabled", label: "Enabled" },
  { id: "disabled", label: "Disabled" },
];

const LIVE_STATUS_LABELS = { all: "All", live: "Live", test: "Test" };

const ACTIVE_STATUS_LABELS = {
  all: "All",
  enabled: "Enabled",
  disabled: "Disabled",
};

export const isDefaultOperatorFilter = (
  liveStatus?: string,
  activeStatus?: string,
) =>
  (liveStatus || "live") === "live" && (activeStatus || "enabled") === "enabled";

export const getOperatorFilterLabel = (
  liveStatus?: string,
  activeStatus?: string,
) =>
  `${LIVE_STATUS_LABELS[liveStatus || "live"]} - ${ACTIVE_STATUS_LABELS[activeStatus || "enabled"]}`;
